<template>
  <RevIllustration
    :alt="logoAlt"
    class="h-[128px] w-[76px] md:h-[98px] md:w-[59px] lg:h-[128px] lg:w-[76px]"
    :height="128"
    src="/img/footer/customer-service-of-the-year.svg"
    :width="76"
  />
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'

import translations from './Footer.translations'

const i18n = useI18n()
const logoAlt = i18n(translations.customerServiceOfTheYearLogoAlt)
</script>
